export class JobPosition {
    constructor(
      id,
      name,
      erpRRHHId,
      deletedAt,
      permissionGroup = null,
    ) {
        this.id = id;
        this.name = name;
        this.erpRRHHId = erpRRHHId;
        this.deletedAt = deletedAt;
        this.permissionGroup = permissionGroup;
    }
    static createFromResponseData(data) {
      if (!data) {
        return null;
      }
      return new JobPosition(
        data.id,
        data.name,
        data.erpRRHHId,
        data.deletedAt,
        data.permissionGroup || null,
      );
    }
  };